import './Form.scss';
import React, { useState } from 'react';
import emailjs from '@emailjs/browser';
import Spinner from '../spinner/Spinner';

export default function Form() {
    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        email: "",
        phoneNumber: "",
        message: ""
    });

    const [errors, setErrors] = useState({});
    const [submitted, setSubmitted] = useState(false);
    const [submittedError, setSubmittedError] = useState(false);
    const [showSpinner, setShowSpinne] = useState(false);

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleBlur = (e) => {
        const { name, value } = e.target;

        if (name === 'firstName' || name === 'lastName') {
            validateName(value, name);
        }
        if (name === 'email') {
            validateEmail(value);
        }
        if (name === 'phoneNumber') {
            validatePhoneNumber(value);
        }
        if (name === 'message') {
            validateMessage(value);
        }
    }

    function validateName(value, name) {
        const newErrors = Object.assign({}, errors);
        if (!value) {
            newErrors[name] = "Dit veld is verplicht";
        } else {
            newErrors[name] = "";
        }

        setErrors(newErrors);
    }


    function validateMessage(value) {
        const newErrors = Object.assign({}, errors);
        if (!value) {
            newErrors.message = "Dit veld is verplicht";
        } else {
            newErrors.message = "";
        }

        setErrors(newErrors);
    }

    function validateEmail(value) {
        const newErrors = Object.assign({}, errors);
        const validEmail = new RegExp('^[a-zA-Z0-9._:$!%-]+@[a-zA-Z0-9.-]+.[a-zA-Z]$');

        if (!value) {
            newErrors.email = "Dit veld is verplicht";
        } else if (!validEmail.test(value)) {
            newErrors.email = "Vul een correct e-mailadres in";
        } else {
            newErrors.email = "";
        }

        setErrors(newErrors);
    }

    function validatePhoneNumber(value) {
        const newErrors = Object.assign({}, errors);
        const validPhone = new RegExp(`^((\\+31)|(0031)|0)(\\(0\\)|)(\\d{1,3})(\\s|\\-|)(\\d{8}|\\d{4}\\s\\d{4}|\\d{2}\\s\\d{2}\\s\\d{2}\\s\\d{2})$`);

        if (!value) {
            newErrors.phoneNumber = "Dit veld is verplicht";
        } else if (!validPhone.test(value)) {
            newErrors.phoneNumber = "Vul een correct telefoonnummer in";
        } else {
            newErrors.phoneNumber = "";
        }

        setErrors(newErrors);
    }

    const validateForm = () => {
        let isValid = true;
        const newErrors = {};

        if (!formData.firstName) {
            newErrors.firstName = "Dit veld is verplicht";
            isValid = false;
        }

        if (!formData.lastName) {
            newErrors.lastName = "Dit veld is verplicht";
            isValid = false;
        }

        if (!formData.email) {
            newErrors.email = "Dit veld is verplicht";
            isValid = false;
        }

        if (!formData.phoneNumber) {
            newErrors.phoneNumber = "Dit veld is verplicht";
            isValid = false;
        }

        if (!formData.message) {
            newErrors.message = "Dit veld is verplicht";
            isValid = false;
        }

        setErrors(newErrors);
        return isValid;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (validateForm()) {
            // Form is valid, you can submit or process the data here
            setShowSpinne(true);
            sendEmail(e.target);
        } else {
            // Form is not valid, display error messages
        }
    };

    function sendEmail(form) {
        let templateParams = {
            firstName: formData.firstName,
            lastName: formData.lastName,
            email: formData.email,
            phoneNumber: formData.phoneNumber,
            message: formData.message
        };

        emailjs
            .send(
                'service_6c2985v',
                'template_uxtqpyu',
                templateParams,
                '8MdLq9JnDOBJzjTZt'
            )
            .then(
                (result) => {
                    setSubmitted(true);
                    setShowSpinne(false);
                    resetForm(form);
                },
                (error) => {
                    setSubmittedError(true);
                    setShowSpinne(false);
                }
            );
    }

    function resetForm(form) {
        form.reset();
        setFormData(Object.assign({}, {
            firstName: "",
            lastName: "",
            email: "",
            phoneNumber: "",
            message: ""
        }));
        console.log(formData);
    }

    const isFormValid = Object.keys(errors).length === 0;

    // handleInputChange(event) {
    //     let touched = 
    //     this.setState({

    //     })
    //     const target = event.target;
    //     const value = target.value;
    //     const name = target.name;

    //     this.setState({
    //         [name]: value
    //     });
    // }

    return (
        <>
            <form noValidate onSubmit={handleSubmit}>
                {submitted && !submittedError && (
                    <p>Thank you for submitting!</p>
                )}
                <div className="stack">
                    <div className="input-field">
                        <label>
                            <span className="margin-top-20">Voornaam</span>
                            <input
                                name="firstName"
                                type="text"
                                onChange={handleInputChange}
                                onBlur={(e) => { handleBlur(e) }}
                                required />
                        </label>
                        {errors.firstName && (
                            <span role="alert" className="error-message">
                                {errors.firstName}
                            </span>
                        )}
                    </div>
                    <div className="input-field">
                        <label>
                            <span className="margin-top-20">Achternaam</span>
                            <input
                                name="lastName"
                                type="text"
                                onChange={handleInputChange}
                                onBlur={(e) => { handleBlur(e) }}
                                required />
                        </label>
                        {errors.lastName && (
                            <span role="alert" className="error-message">
                                {errors.lastName}
                            </span>
                        )}
                    </div>
                </div>
                <div className="input-field">
                    <label>
                        <span className="margin-top-20">Email</span>
                        <input
                            name="email"
                            type="text"
                            onChange={handleInputChange}
                            onBlur={(e) => { handleBlur(e) }}
                            required />
                    </label>
                    {errors.email && (
                        <span role="alert" className="error-message">
                            {errors.email}
                        </span>
                    )}
                </div>
                <div className="input-field">
                    <label>
                        <span className="margin-top-20">Telefoonnummer</span>
                        <input
                            name="phoneNumber"
                            type="text"
                            onChange={handleInputChange}
                            onBlur={(e) => { handleBlur(e) }}
                            required />
                    </label>
                    {errors.phoneNumber && (
                        <span role="alert" className="error-message">
                            {errors.phoneNumber}
                        </span>
                    )}
                </div>
                <div className="input-field">
                    <label>
                        <span className="margin-top-20">Bericht</span>
                        <textarea
                            name="message"
                            type="text"
                            onChange={handleInputChange}
                            onBlur={(e) => { handleBlur(e) }}
                            required />
                    </label>
                    {errors.message && (
                        <span role="alert" className="error-message">
                            {errors.message}
                        </span>
                    )}
                </div>
                <button type="submit" className='submit-button margin-top-20'>
                    {showSpinner ? <Spinner /> : 'Verzenden'}
                </button>
            </form>
        </>
    );
}